{
  "items": [
    {
      "city": "Riga",
      "lat": "56.9475",
      "lng": "24.1069",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rīga",
      "capital": "primary",
      "population": "614618",
      "population_proper": "614618"
    },
    {
      "city": "Daugavpils",
      "lat": "55.8714",
      "lng": "26.5161",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Daugavpils Novads",
      "capital": "admin",
      "population": "80627",
      "population_proper": "80627"
    },
    {
      "city": "Liepāja",
      "lat": "56.5083",
      "lng": "21.0111",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Liepāja",
      "capital": "admin",
      "population": "67964",
      "population_proper": "67964"
    },
    {
      "city": "Jelgava",
      "lat": "56.6522",
      "lng": "23.7244",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jelgavas Novads",
      "capital": "admin",
      "population": "55336",
      "population_proper": "55336"
    },
    {
      "city": "Jūrmala",
      "lat": "56.9680",
      "lng": "23.7704",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jūrmala",
      "capital": "admin",
      "population": "50248",
      "population_proper": "50248"
    },
    {
      "city": "Ventspils",
      "lat": "57.3897",
      "lng": "21.5644",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ventspils",
      "capital": "admin",
      "population": "33372",
      "population_proper": "33372"
    },
    {
      "city": "Rēzekne",
      "lat": "56.5067",
      "lng": "27.3308",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rēzeknes Novads",
      "capital": "admin",
      "population": "26839",
      "population_proper": "26839"
    },
    {
      "city": "Ogre",
      "lat": "56.8169",
      "lng": "24.6047",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ogres Novads",
      "capital": "admin",
      "population": "22978",
      "population_proper": "22978"
    },
    {
      "city": "Valmiera",
      "lat": "57.5381",
      "lng": "25.4231",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Valmiera",
      "capital": "admin",
      "population": "22971",
      "population_proper": "22971"
    },
    {
      "city": "Jēkabpils",
      "lat": "56.4975",
      "lng": "25.8664",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jēkabpils Novads",
      "capital": "admin",
      "population": "21629",
      "population_proper": "21629"
    },
    {
      "city": "Salaspils",
      "lat": "56.8614",
      "lng": "24.3500",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Salaspils Novads",
      "capital": "admin",
      "population": "17905",
      "population_proper": "17905"
    },
    {
      "city": "Mārupe",
      "lat": "56.9008",
      "lng": "24.0478",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mārupes Novads",
      "capital": "admin",
      "population": "16826",
      "population_proper": "16826"
    },
    {
      "city": "Tukums",
      "lat": "56.9669",
      "lng": "23.1531",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Tukuma Novads",
      "capital": "admin",
      "population": "16691",
      "population_proper": "16691"
    },
    {
      "city": "Cēsis",
      "lat": "57.3131",
      "lng": "25.2747",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Cēsu Novads",
      "capital": "admin",
      "population": "14815",
      "population_proper": "14815"
    },
    {
      "city": "Sigulda",
      "lat": "57.1539",
      "lng": "24.8544",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Siguldas Novads",
      "capital": "admin",
      "population": "14396",
      "population_proper": "14396"
    },
    {
      "city": "Olaine",
      "lat": "56.7844",
      "lng": "23.9369",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Olaines Novads",
      "capital": "admin",
      "population": "10324",
      "population_proper": "10324"
    },
    {
      "city": "Kuldīga",
      "lat": "56.9672",
      "lng": "21.9700",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Kuldīgas Novads",
      "capital": "admin",
      "population": "10109",
      "population_proper": "10109"
    },
    {
      "city": "Bauska",
      "lat": "56.4067",
      "lng": "24.1875",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Bauskas Novads",
      "capital": "admin",
      "population": "9840",
      "population_proper": "9840"
    },
    {
      "city": "Saldus",
      "lat": "56.6667",
      "lng": "22.4936",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Saldus Novads",
      "capital": "admin",
      "population": "9679",
      "population_proper": "9679"
    },
    {
      "city": "Talsi",
      "lat": "57.2447",
      "lng": "22.5889",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Talsu Novads",
      "capital": "admin",
      "population": "8816",
      "population_proper": "8816"
    },
    {
      "city": "Dobele",
      "lat": "56.6258",
      "lng": "23.2811",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Dobeles Novads",
      "capital": "admin",
      "population": "8731",
      "population_proper": "8731"
    },
    {
      "city": "Ludza",
      "lat": "56.5439",
      "lng": "27.7211",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ludzas Novads",
      "capital": "admin",
      "population": "7473",
      "population_proper": "7473"
    },
    {
      "city": "Krāslava",
      "lat": "55.8956",
      "lng": "27.1644",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Krāslavas Novads",
      "capital": "admin",
      "population": "7289",
      "population_proper": "7289"
    },
    {
      "city": "Ikšķile",
      "lat": "56.8367",
      "lng": "24.4964",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ikšķiles Novads",
      "capital": "admin",
      "population": "7278",
      "population_proper": "7278"
    },
    {
      "city": "Ādaži",
      "lat": "57.0769",
      "lng": "24.3236",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ādažu Novads",
      "capital": "admin",
      "population": "7154",
      "population_proper": "7154"
    },
    {
      "city": "Aizkraukle",
      "lat": "56.6008",
      "lng": "25.2550",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Aizkraukles Novads",
      "capital": "admin",
      "population": "7044",
      "population_proper": "7044"
    },
    {
      "city": "Līvāni",
      "lat": "56.3539",
      "lng": "26.1761",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Līvānu Novads",
      "capital": "admin",
      "population": "7035",
      "population_proper": "7035"
    },
    {
      "city": "Gulbene",
      "lat": "57.1750",
      "lng": "26.7564",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Gulbenes Novads",
      "capital": "admin",
      "population": "6982",
      "population_proper": "6982"
    },
    {
      "city": "Limbaži",
      "lat": "57.5147",
      "lng": "24.7131",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Limbažu Novads",
      "capital": "admin",
      "population": "6888",
      "population_proper": "6888"
    },
    {
      "city": "Madona",
      "lat": "56.8542",
      "lng": "26.2200",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Madonas Novads",
      "capital": "admin",
      "population": "6792",
      "population_proper": "6792"
    },
    {
      "city": "Baloži",
      "lat": "56.8750",
      "lng": "24.1194",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ķekavas Novads",
      "capital": "",
      "population": "6780",
      "population_proper": "6780"
    },
    {
      "city": "Alūksne",
      "lat": "57.4239",
      "lng": "27.0503",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Alūksnes Novads",
      "capital": "admin",
      "population": "6535",
      "population_proper": "6535"
    },
    {
      "city": "Preiļi",
      "lat": "56.2942",
      "lng": "26.7247",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Preiļu Novads",
      "capital": "admin",
      "population": "6161",
      "population_proper": "6161"
    },
    {
      "city": "Lielvārde",
      "lat": "56.7175",
      "lng": "24.8106",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Lielvārdes Novads",
      "capital": "admin",
      "population": "5907",
      "population_proper": "5907"
    },
    {
      "city": "Balvi",
      "lat": "57.1292",
      "lng": "27.2667",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Balvu Novads",
      "capital": "admin",
      "population": "5840",
      "population_proper": "5840"
    },
    {
      "city": "Iecava",
      "lat": "56.6000",
      "lng": "24.2000",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Iecavas Novads",
      "capital": "admin",
      "population": "5736",
      "population_proper": "5736"
    },
    {
      "city": "Smiltene",
      "lat": "57.4242",
      "lng": "25.9064",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Smiltenes Novads",
      "capital": "admin",
      "population": "5151",
      "population_proper": "5151"
    },
    {
      "city": "Ķekava",
      "lat": "56.8266",
      "lng": "24.2300",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ķekavas Novads",
      "capital": "admin",
      "population": "5134",
      "population_proper": "5134"
    },
    {
      "city": "Carnikava",
      "lat": "57.1333",
      "lng": "24.2833",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Carnikavas Novads",
      "capital": "admin",
      "population": "4812",
      "population_proper": "4812"
    },
    {
      "city": "Valka",
      "lat": "57.7753",
      "lng": "26.0214",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Valkas Novads",
      "capital": "admin",
      "population": "4510",
      "population_proper": "4510"
    },
    {
      "city": "Ozolnieki",
      "lat": "56.6908",
      "lng": "23.7881",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ozolnieku Novads",
      "capital": "admin",
      "population": "4260",
      "population_proper": "4260"
    },
    {
      "city": "Aizpute",
      "lat": "56.7211",
      "lng": "21.6017",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Aizputes Novads",
      "capital": "admin",
      "population": "4036",
      "population_proper": "4036"
    },
    {
      "city": "Piņķi",
      "lat": "56.9444",
      "lng": "23.9108",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Babītes Novads",
      "capital": "admin",
      "population": "3695",
      "population_proper": "3695"
    },
    {
      "city": "Baldone",
      "lat": "56.7425",
      "lng": "24.3908",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Baldones Novads",
      "capital": "admin",
      "population": "3664",
      "population_proper": "3664"
    },
    {
      "city": "Grobiņa",
      "lat": "56.5375",
      "lng": "21.1675",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Grobiņas Novads",
      "capital": "admin",
      "population": "3522",
      "population_proper": "3522"
    },
    {
      "city": "Jaunolaine",
      "lat": "56.7989",
      "lng": "23.9891",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Olaines Novads",
      "capital": "",
      "population": "3364",
      "population_proper": "3364"
    },
    {
      "city": "Kandava",
      "lat": "57.0364",
      "lng": "22.7761",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Kandavas Novads",
      "capital": "admin",
      "population": "3336",
      "population_proper": "3336"
    },
    {
      "city": "Vangaži",
      "lat": "57.0919",
      "lng": "24.5486",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Inčukalna Novads",
      "capital": "",
      "population": "3235",
      "population_proper": "3235"
    },
    {
      "city": "Jaunmārupe",
      "lat": "56.8764",
      "lng": "23.9358",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mārupes Novads",
      "capital": "",
      "population": "3212",
      "population_proper": "3212"
    },
    {
      "city": "Saulkrasti",
      "lat": "57.2636",
      "lng": "24.4164",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Saulkrastu Novads",
      "capital": "admin",
      "population": "3120",
      "population_proper": "3120"
    },
    {
      "city": "Ulbroka",
      "lat": "56.9408",
      "lng": "24.2861",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Stopiņu Novads",
      "capital": "admin",
      "population": "3102",
      "population_proper": "3102"
    },
    {
      "city": "Pļaviņas",
      "lat": "56.6161",
      "lng": "25.7217",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Pļaviņu Novads",
      "capital": "admin",
      "population": "2908",
      "population_proper": "2908"
    },
    {
      "city": "Brocēni",
      "lat": "56.6833",
      "lng": "22.5664",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Brocēnu Novads",
      "capital": "admin",
      "population": "2830",
      "population_proper": "2830"
    },
    {
      "city": "Viļāni",
      "lat": "56.5528",
      "lng": "26.9253",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Viļānu Novads",
      "capital": "admin",
      "population": "2793",
      "population_proper": "2793"
    },
    {
      "city": "Rūjiena",
      "lat": "57.8969",
      "lng": "25.3261",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rūjienas Novads",
      "capital": "admin",
      "population": "2725",
      "population_proper": "2725"
    },
    {
      "city": "Koknese",
      "lat": "56.6500",
      "lng": "25.4333",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Kokneses Novads",
      "capital": "admin",
      "population": "2580",
      "population_proper": "2580"
    },
    {
      "city": "Salacgrīva",
      "lat": "57.7494",
      "lng": "24.3586",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Salacgrīvas Novads",
      "capital": "admin",
      "population": "2579",
      "population_proper": "2579"
    },
    {
      "city": "Skrīveri",
      "lat": "56.6467",
      "lng": "25.1222",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Skrīveru Novads",
      "capital": "admin",
      "population": "2425",
      "population_proper": "2425"
    },
    {
      "city": "Valmiermuiža",
      "lat": "57.5564",
      "lng": "25.4314",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Burtnieku Novads",
      "capital": "",
      "population": "2392",
      "population_proper": "2392"
    },
    {
      "city": "Katlakalns",
      "lat": "56.8744",
      "lng": "24.1808",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ķekavas Novads",
      "capital": "",
      "population": "2297",
      "population_proper": "2297"
    },
    {
      "city": "Kadaga",
      "lat": "57.0944",
      "lng": "24.3650",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ādažu Novads",
      "capital": "",
      "population": "2281",
      "population_proper": "2281"
    },
    {
      "city": "Auce",
      "lat": "56.4611",
      "lng": "22.8942",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Auces Novads",
      "capital": "admin",
      "population": "2236",
      "population_proper": "2236"
    },
    {
      "city": "Liepa",
      "lat": "57.3864",
      "lng": "25.4231",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Priekuļu Novads",
      "capital": "",
      "population": "2202",
      "population_proper": "2202"
    },
    {
      "city": "Malta",
      "lat": "56.3472",
      "lng": "27.1644",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rēzeknes Novads",
      "capital": "",
      "population": "2202",
      "population_proper": "2202"
    },
    {
      "city": "Priekuļi",
      "lat": "57.3142",
      "lng": "25.3597",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Priekuļu Novads",
      "capital": "admin",
      "population": "2183",
      "population_proper": "2183"
    },
    {
      "city": "Ilūkste",
      "lat": "55.9781",
      "lng": "26.2967",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ilūkstes Novads",
      "capital": "admin",
      "population": "2169",
      "population_proper": "2169"
    },
    {
      "city": "Roja",
      "lat": "57.5031",
      "lng": "22.8106",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rojas Novads",
      "capital": "admin",
      "population": "2140",
      "population_proper": "2140"
    },
    {
      "city": "Ķegums",
      "lat": "56.7444",
      "lng": "24.7214",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ķeguma Novads",
      "capital": "admin",
      "population": "2103",
      "population_proper": "2103"
    },
    {
      "city": "Vecumnieki",
      "lat": "56.6064",
      "lng": "24.5222",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Vecumnieku Novads",
      "capital": "admin",
      "population": "2053",
      "population_proper": "2053"
    },
    {
      "city": "Garkalne",
      "lat": "57.0458",
      "lng": "24.4186",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Garkalnes Novads",
      "capital": "admin",
      "population": "2019",
      "population_proper": "2019"
    },
    {
      "city": "Zvejniekciems",
      "lat": "57.3169",
      "lng": "24.4156",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Saulkrastu Novads",
      "capital": "",
      "population": "2016",
      "population_proper": "2016"
    },
    {
      "city": "Inčukalns",
      "lat": "57.0964",
      "lng": "24.6875",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Inčukalna Novads",
      "capital": "admin",
      "population": "1985",
      "population_proper": "1985"
    },
    {
      "city": "Kārsava",
      "lat": "56.7867",
      "lng": "27.6739",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Kārsavas Novads",
      "capital": "admin",
      "population": "1923",
      "population_proper": "1923"
    },
    {
      "city": "Skrunda",
      "lat": "56.6756",
      "lng": "22.0164",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Skrundas Novads",
      "capital": "admin",
      "population": "1906",
      "population_proper": "1906"
    },
    {
      "city": "Dagda",
      "lat": "56.0947",
      "lng": "27.5369",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Dagdas Novads",
      "capital": "admin",
      "population": "1895",
      "population_proper": "1895"
    },
    {
      "city": "Priekule",
      "lat": "56.4472",
      "lng": "21.5933",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Priekules Novads",
      "capital": "admin",
      "population": "1851",
      "population_proper": "1851"
    },
    {
      "city": "Saurieši",
      "lat": "56.9194",
      "lng": "24.3650",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Stopiņu Novads",
      "capital": "",
      "population": "1815",
      "population_proper": "1815"
    },
    {
      "city": "Mālpils",
      "lat": "57.0100",
      "lng": "24.9581",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mālpils Novads",
      "capital": "admin",
      "population": "1804",
      "population_proper": "1804"
    },
    {
      "city": "Jaunjelgava",
      "lat": "56.6175",
      "lng": "25.0814",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jaunjelgavas Novads",
      "capital": "admin",
      "population": "1768",
      "population_proper": "1768"
    },
    {
      "city": "Varakļāni",
      "lat": "56.6078",
      "lng": "26.7550",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Varakļānu Novads",
      "capital": "admin",
      "population": "1730",
      "population_proper": "1730"
    },
    {
      "city": "Kalnciems",
      "lat": "56.8000",
      "lng": "23.6000",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jelgavas Novads",
      "capital": "",
      "population": "1714",
      "population_proper": "1714"
    },
    {
      "city": "Ērgļi",
      "lat": "56.8975",
      "lng": "25.6375",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ērgļu Novads",
      "capital": "admin",
      "population": "1700",
      "population_proper": "1700"
    },
    {
      "city": "Ropaži",
      "lat": "56.9718",
      "lng": "24.6318",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ropažu Novads",
      "capital": "admin",
      "population": "1661",
      "population_proper": "1661"
    },
    {
      "city": "Ugāle",
      "lat": "57.2769",
      "lng": "22.0217",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ventspils Novads",
      "capital": "",
      "population": "1589",
      "population_proper": "1589"
    },
    {
      "city": "Eleja",
      "lat": "56.4067",
      "lng": "23.6875",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jelgavas Novads",
      "capital": "",
      "population": "1574",
      "population_proper": "1574"
    },
    {
      "city": "Tīraine",
      "lat": "56.8878",
      "lng": "24.0694",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mārupes Novads",
      "capital": "",
      "population": "1568",
      "population_proper": "1568"
    },
    {
      "city": "Vaiņode",
      "lat": "56.4185",
      "lng": "21.8523",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Vaiņodes Novads",
      "capital": "admin",
      "population": "1563",
      "population_proper": "1563"
    },
    {
      "city": "Stende",
      "lat": "57.1450",
      "lng": "22.5347",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Talsu Novads",
      "capital": "",
      "population": "1559",
      "population_proper": "1559"
    },
    {
      "city": "Viesīte",
      "lat": "56.3453",
      "lng": "25.5569",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Viesītes Novads",
      "capital": "admin",
      "population": "1533",
      "population_proper": "1533"
    },
    {
      "city": "Lubāna",
      "lat": "56.9017",
      "lng": "26.7228",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Lubānas Novads",
      "capital": "admin",
      "population": "1511",
      "population_proper": "1511"
    },
    {
      "city": "Ogresgals",
      "lat": "56.8061",
      "lng": "24.7436",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ogres Novads",
      "capital": "",
      "population": "1501",
      "population_proper": "1501"
    },
    {
      "city": "Medemciems",
      "lat": "56.8594",
      "lng": "24.0717",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Olaines Novads",
      "capital": "",
      "population": "1491",
      "population_proper": "1491"
    },
    {
      "city": "Augšlīgatne",
      "lat": "57.1869",
      "lng": "25.0361",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Līgatnes Novads",
      "capital": "",
      "population": "1435",
      "population_proper": "1435"
    },
    {
      "city": "Garciems",
      "lat": "57.1028",
      "lng": "24.2053",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Carnikavas Novads",
      "capital": "",
      "population": "1418",
      "population_proper": "1418"
    },
    {
      "city": "Dundaga",
      "lat": "57.5167",
      "lng": "22.3500",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Dundagas Novads",
      "capital": "admin",
      "population": "1400",
      "population_proper": "1400"
    },
    {
      "city": "Rāmava",
      "lat": "56.8875",
      "lng": "24.1578",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ķekavas Novads",
      "capital": "",
      "population": "1387",
      "population_proper": "1387"
    },
    {
      "city": "Sabile",
      "lat": "57.0458",
      "lng": "22.5728",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Talsu Novads",
      "capital": "",
      "population": "1347",
      "population_proper": "1347"
    },
    {
      "city": "Āne",
      "lat": "56.6471",
      "lng": "23.8123",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ozolnieku Novads",
      "capital": "",
      "population": "1336",
      "population_proper": "1336"
    },
    {
      "city": "Mērsrags",
      "lat": "57.3333",
      "lng": "23.1250",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mērsraga Novads",
      "capital": "admin",
      "population": "1332",
      "population_proper": "1332"
    },
    {
      "city": "Zilupe",
      "lat": "56.3856",
      "lng": "28.1225",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Zilupes Novads",
      "capital": "admin",
      "population": "1321",
      "population_proper": "1321"
    },
    {
      "city": "Mežāres",
      "lat": "56.9642",
      "lng": "23.9625",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Babītes Novads",
      "capital": "",
      "population": "1315",
      "population_proper": "1315"
    },
    {
      "city": "Engure",
      "lat": "57.1606",
      "lng": "23.2244",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Engures Novads",
      "capital": "",
      "population": "1310",
      "population_proper": "1310"
    },
    {
      "city": "Lapmežciems",
      "lat": "57.0011",
      "lng": "23.5150",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Engures Novads",
      "capital": "",
      "population": "1287",
      "population_proper": "1287"
    },
    {
      "city": "Upeslejas",
      "lat": "56.9242",
      "lng": "24.3831",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Stopiņu Novads",
      "capital": "",
      "population": "1281",
      "population_proper": "1281"
    },
    {
      "city": "Babīte",
      "lat": "56.9567",
      "lng": "23.9472",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Babītes Novads",
      "capital": "",
      "population": "1273",
      "population_proper": "1273"
    },
    {
      "city": "Gauja",
      "lat": "57.1403",
      "lng": "24.2858",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Carnikavas Novads",
      "capital": "",
      "population": "1261",
      "population_proper": "1261"
    },
    {
      "city": "Upesciems",
      "lat": "56.9819",
      "lng": "24.3375",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Garkalnes Novads",
      "capital": "",
      "population": "1258",
      "population_proper": "1258"
    },
    {
      "city": "Saulkalne",
      "lat": "56.8444",
      "lng": "24.4325",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Salaspils Novads",
      "capital": "",
      "population": "1257",
      "population_proper": "1257"
    },
    {
      "city": "Cesvaine",
      "lat": "56.9683",
      "lng": "26.3067",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Cesvaines Novads",
      "capital": "admin",
      "population": "1239",
      "population_proper": "1239"
    },
    {
      "city": "Rītausmas",
      "lat": "56.3814",
      "lng": "24.1708",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Bauskas Novads",
      "capital": "",
      "population": "1236",
      "population_proper": "1236"
    },
    {
      "city": "Rauna",
      "lat": "57.3319",
      "lng": "25.6097",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Raunas Novads",
      "capital": "admin",
      "population": "1218",
      "population_proper": "1218"
    },
    {
      "city": "Viļaka",
      "lat": "57.1842",
      "lng": "27.6722",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Viļakas Novads",
      "capital": "admin",
      "population": "1216",
      "population_proper": "1216"
    },
    {
      "city": "Stūnīši",
      "lat": "56.8503",
      "lng": "24.0492",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Olaines Novads",
      "capital": "",
      "population": "1215",
      "population_proper": "1215"
    },
    {
      "city": "Bēne",
      "lat": "56.4831",
      "lng": "23.0622",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Auces Novads",
      "capital": "",
      "population": "1203",
      "population_proper": "1203"
    },
    {
      "city": "Valdemārpils",
      "lat": "57.3706",
      "lng": "22.5919",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Talsu Novads",
      "capital": "",
      "population": "1165",
      "population_proper": "1165"
    },
    {
      "city": "Silakrogs",
      "lat": "56.9639",
      "lng": "24.4292",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ropažu Novads",
      "capital": "",
      "population": "1161",
      "population_proper": "1161"
    },
    {
      "city": "Ragana",
      "lat": "57.1797",
      "lng": "24.7033",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Krimuldas Novads",
      "capital": "admin",
      "population": "1155",
      "population_proper": "1155"
    },
    {
      "city": "Gardene",
      "lat": "56.6489",
      "lng": "23.2158",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Dobeles Novads",
      "capital": "",
      "population": "1149",
      "population_proper": "1149"
    },
    {
      "city": "Skulte",
      "lat": "56.9186",
      "lng": "23.9489",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mārupes Novads",
      "capital": "",
      "population": "1128",
      "population_proper": "1128"
    },
    {
      "city": "Mazsalaca",
      "lat": "57.8667",
      "lng": "25.0500",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Mazsalacas Novads",
      "capital": "admin",
      "population": "1124",
      "population_proper": "1124"
    },
    {
      "city": "Seda",
      "lat": "57.6506",
      "lng": "25.7511",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Strenču Novads",
      "capital": "",
      "population": "1098",
      "population_proper": "1098"
    },
    {
      "city": "Aloja",
      "lat": "57.7669",
      "lng": "24.8828",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Alojas Novads",
      "capital": "admin",
      "population": "1091",
      "population_proper": "1091"
    },
    {
      "city": "Kalngale",
      "lat": "57.0819",
      "lng": "24.1599",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Carnikavas Novads",
      "capital": "",
      "population": "1086",
      "population_proper": "1086"
    },
    {
      "city": "Lociki",
      "lat": "55.9392",
      "lng": "26.6478",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Daugavpils Novads",
      "capital": "",
      "population": "1066",
      "population_proper": "1066"
    },
    {
      "city": "Druva",
      "lat": "56.6953",
      "lng": "22.4489",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Saldus Novads",
      "capital": "",
      "population": "1045",
      "population_proper": "1045"
    },
    {
      "city": "Jumprava",
      "lat": "56.6756",
      "lng": "24.9725",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Lielvārdes Novads",
      "capital": "",
      "population": "1043",
      "population_proper": "1043"
    },
    {
      "city": "Līgatne",
      "lat": "57.2336",
      "lng": "25.0397",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Līgatnes Novads",
      "capital": "admin",
      "population": "1015",
      "population_proper": "1015"
    },
    {
      "city": "Aknīste",
      "lat": "56.1622",
      "lng": "25.7411",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Aknīstes Novads",
      "capital": "admin",
      "population": "1011",
      "population_proper": "1011"
    },
    {
      "city": "Nereta",
      "lat": "56.2044",
      "lng": "25.3078",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Neretas Novads",
      "capital": "admin",
      "population": "1008",
      "population_proper": "1008"
    },
    {
      "city": "Strenči",
      "lat": "57.6272",
      "lng": "25.6850",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Strenču Novads",
      "capital": "admin",
      "population": "988",
      "population_proper": "988"
    },
    {
      "city": "Nīca",
      "lat": "56.3458",
      "lng": "21.0644",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Nīcas Novads",
      "capital": "admin",
      "population": "974",
      "population_proper": "974"
    },
    {
      "city": "Kocēni",
      "lat": "57.5214",
      "lng": "25.3381",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Kocēnu Novads",
      "capital": "admin",
      "population": "949",
      "population_proper": "949"
    },
    {
      "city": "Jaunpiebalga",
      "lat": "57.1797",
      "lng": "26.0544",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jaunpiebalgas Novads",
      "capital": "admin",
      "population": "880",
      "population_proper": "880"
    },
    {
      "city": "Pāvilosta",
      "lat": "56.8878",
      "lng": "21.1842",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Pāvilostas Novads",
      "capital": "admin",
      "population": "860",
      "population_proper": "860"
    },
    {
      "city": "Aglona",
      "lat": "56.1233",
      "lng": "27.0167",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Aglonas Novads",
      "capital": "admin",
      "population": "833",
      "population_proper": "833"
    },
    {
      "city": "Ape",
      "lat": "57.5392",
      "lng": "26.6928",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Apes Novads",
      "capital": "admin",
      "population": "808",
      "population_proper": "808"
    },
    {
      "city": "Jaunpils",
      "lat": "56.7314",
      "lng": "23.0125",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Jaunpils Novads",
      "capital": "admin",
      "population": "797",
      "population_proper": "797"
    },
    {
      "city": "Riebiņi",
      "lat": "56.3394",
      "lng": "26.7975",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Riebiņu Novads",
      "capital": "admin",
      "population": "719",
      "population_proper": "719"
    },
    {
      "city": "Pilsrundāle",
      "lat": "56.4200",
      "lng": "24.0097",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rundāles Novads",
      "capital": "admin",
      "population": "697",
      "population_proper": "697"
    },
    {
      "city": "Alsunga",
      "lat": "56.9803",
      "lng": "21.5667",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Alsungas Novads",
      "capital": "admin",
      "population": "684",
      "population_proper": "684"
    },
    {
      "city": "Naukšēni",
      "lat": "57.8836",
      "lng": "25.4528",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Naukšēnu Novads",
      "capital": "admin",
      "population": "651",
      "population_proper": "651"
    },
    {
      "city": "Smārde",
      "lat": "56.9550",
      "lng": "23.3381",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Engures Novads",
      "capital": "admin",
      "population": "620",
      "population_proper": "620"
    },
    {
      "city": "Rucava",
      "lat": "56.1592",
      "lng": "21.1619",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rucavas Novads",
      "capital": "admin",
      "population": "495",
      "population_proper": "495"
    },
    {
      "city": "Rugāji",
      "lat": "56.9994",
      "lng": "27.1269",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Rugāju Novads",
      "capital": "admin",
      "population": "486",
      "population_proper": "486"
    },
    {
      "city": "Vecpiebalga",
      "lat": "57.0619",
      "lng": "25.8108",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Vecpiebalgas Novads",
      "capital": "admin",
      "population": "457",
      "population_proper": "457"
    },
    {
      "city": "Baltinava",
      "lat": "56.9447",
      "lng": "27.6447",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Baltinavas Novads",
      "capital": "admin",
      "population": "443",
      "population_proper": "443"
    },
    {
      "city": "Mūrmuiža",
      "lat": "57.4731",
      "lng": "25.4917",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Beverīnas Novads",
      "capital": "admin",
      "population": "440",
      "population_proper": "440"
    },
    {
      "city": "Burtnieki",
      "lat": "57.6947",
      "lng": "25.2750",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Burtnieku Novads",
      "capital": "admin",
      "population": "418",
      "population_proper": "418"
    },
    {
      "city": "Lieģi",
      "lat": "56.5828",
      "lng": "21.3331",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Durbes Novads",
      "capital": "admin",
      "population": "400",
      "population_proper": "400"
    },
    {
      "city": "Stalbe",
      "lat": "57.3711",
      "lng": "25.0322",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Pārgaujas Novads",
      "capital": "admin",
      "population": "356",
      "population_proper": "356"
    },
    {
      "city": "Tērvete",
      "lat": "56.4497",
      "lng": "23.3594",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Tērvetes Novads",
      "capital": "admin",
      "population": "331",
      "population_proper": "331"
    },
    {
      "city": "Loja",
      "lat": "57.1528",
      "lng": "24.6444",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Sējas Novads",
      "capital": "admin",
      "population": "217",
      "population_proper": "217"
    },
    {
      "city": "Cibla",
      "lat": "56.5500",
      "lng": "27.8839",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Ciblas Novads",
      "capital": "admin",
      "population": "161",
      "population_proper": "161"
    },
    {
      "city": "Vecvārkava",
      "lat": "56.1983",
      "lng": "26.5083",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Vārkavas Novads",
      "capital": "admin",
      "population": "157",
      "population_proper": "157"
    },
    {
      "city": "Drabeši",
      "lat": "57.2425",
      "lng": "25.2825",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Amatas Novads",
      "capital": "admin",
      "population": "119",
      "population_proper": "119"
    },
    {
      "city": "Sala",
      "lat": "56.5047",
      "lng": "25.7618",
      "country": "Latvia",
      "iso2": "LV",
      "admin_name": "Salas Novads",
      "capital": "admin",
      "population": "",
      "population_proper": ""
    }
  ]
}
